export function numberFormat(val: number) {
  return val.toLocaleString("nb-NO");
}
